import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { TableColumn } from "../../../Component/Model/Table/Table";
import { JobTitles } from "../../../Component/Model/Dto/WSP/JobTitles";

interface JobTitlesRows {
    jobTitleId: number;
    jobTitle: string;
    majorGroup: string;
    subMajorGroup: string;
    minorGroup: string;
    unitGroup: string;
    occupationGroup: string;
    ofoCode: string;
    actions: any;
}

interface OFOCodesCategorisationsTable {
    columns: Array<TableColumn>;
    rows: Array<JobTitlesRows>;
}

export function OFOCodesCategorisationMapper(dataObject: JobTitles[], editOfoCodeRecord: (id: number) => void, deleteJobTitle: (id: number, jobTitleName: string) => void): OFOCodesCategorisationsTable {

    const columns = [
        { Header: 'Job Title', accessor: 'jobTitle', id: 'JobTitleName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Major Group', accessor: 'majorGroup', id: 'MajorGroupValue', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Sub-major Group', accessor: 'subMajorGroup', id: 'SubMajorGroupValue', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Minor Group', accessor: 'minorGroup', id: 'MinorGroupValue', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Unit Group', accessor: 'unitGroup', id: 'UnitGroupValue', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Occupation', accessor: 'occupationGroup', id: 'OccupationGroupValue', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'OFO Code', accessor: 'ofoCode', id: 'ofoCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject != undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: JobTitles, index: number) => ({
            jobTitleId: item.jobTitleId,
            jobTitle: item.jobTitleName,
            majorGroup: item.majorGroupValue,
            subMajorGroup: item.subMajorGroupValue,
            minorGroup: item.minorGroupValue,
            unitGroup: item.unitGroupValue,
            occupationGroup: item.occupationGroupValue,
            ofoCode: item.ofoCode,
            actions: [                              
                {
                key: index.toString(),
                label: 'Edit',
                action: () => {
                    editOfoCodeRecord(item.jobTitleId);
                },
                icon: {
                    color: 'info',
                    name: 'edit'
                }
            },                
            {
                type: 'Delete',
                key: index.toString(),
                label: 'Delete',
                action: () => {
                    deleteJobTitle(item.jobTitleId, item.jobTitleName);
                },
                icon: {
                    color: 'error',
                    name: 'delete'
                }
            }
        ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}